import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';
import { MaterialDetailSectionProps } from '../../../@types/transactions';

const MaterialDetailSection: React.FC<MaterialDetailSectionProps> = ({
  getFieldProps,
  touched,
  errors,
  isEdit
}) => (
  <>
    <Typography variant="h6" gutterBottom>
      Material Detail
    </Typography>

    <Stack direction="row" spacing={2}>
      <TextField
        fullWidth
        label="Description"
        disabled={isEdit}
        {...getFieldProps('ServiceDescription')}
        error={Boolean(touched.ServiceDescription && errors.ServiceDescription)}
        helperText={touched.ServiceDescription && errors.ServiceDescription}
      />
      <TextField
        fullWidth
        label="Source Site Name"
        disabled={isEdit}
        {...getFieldProps('SourceSiteName')}
        error={Boolean(touched.SourceSiteName && errors.SourceSiteName)}
        helperText={touched.SourceSiteName && errors.SourceSiteName}
      />
    </Stack>
  </>
);

export default MaterialDetailSection;
